<template>
  <div class="pricing-calculator shadow-4 mb6 pa5-l pa4 bg-white br3 relative">
    <section :class="state.infoPanelOpen ? 'blurred' : '' ">
      <hgroup>
        <h2 class="text-extra-bold">Estimate Your Costs</h2>
        <h3>Determine what plan would best suit your needs, and estimate monthly costs.</h3>
      </hgroup>

      <div class="flex flex-row-l flex-column">
        <div class="calc-form w-40-l w-100 mr4-l">

          <pricing-form />

          <div class="f4 lh-title gray mt4 mb4">
            <em>
              Price does not include domain registration.

              <contact-sales-modal>
                <a href="#">contact sales</a>
              </contact-sales-modal>

              for discounts available for high-volume zones on the Enterprise plan.
            </em>
          </div>
        </div>

        <div class="calc-plans w-60-l w-100">
          <pricing-results />
        </div>
      </div>
    </section>

    <pricing-information />

  </div>
</template>

<script>
import PricingForm from './pricing-form.vue';
import PricingResults from './pricing-results.vue';
import state from './state.js';
import PricingInformation from './pricing-information.vue';
import ContactSalesModal from '../contact-sales-modal/component.vue';

export default {
  name: 'PricingCalculator',
  components: { PricingForm, PricingResults, PricingInformation, ContactSalesModal },

  props: {
    plans: {
      type: Array,
      required: true
    }
  },

  mounted () {
    state.commitPlans(this.plans);
    if (window.location.hash === '#pricing-calculator') this.$el.scrollIntoView({ behavior: 'smooth' });
  },

  provide () {
    return { state };
  },

  data () {
    return { state };
  }
};
</script>

<style scoped lang="scss">
@import "~/stylesheets/application/colors";

.pricing-calculator {
  overflow: hidden;
}

section{
  transition: all .4s ease;

  &.blurred {
    filter: blur(3px);
  }
}

hgroup {
  border-bottom: 1px solid $gray-300;
  margin-bottom: 3rem;
  padding-bottom: 3rem;

  h3 {
    font-weight: 200;
  }
}

</style>
